<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-dropdown trigger="click" @command="exportFile">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_export') || '导出'"
              placement="top"
            >
              <i class="el-icon-download tool-btn"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="task in exportTasks"
                :key="task.templateGroup"
                :command="{ ...row, ...task }"
              >
                {{ task.exportName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_settlementComplete') || '发运完成'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="settlementCompleted(row.shipmentCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ExportPackingOrder
      ref="packingOrder"
      v-if="exportPackingOrderOptions.visible"
      :title="
        $l('INDEX.tips_select_the_booking_record_to_export_notice') ||
          '选择需要导出发运通知书的订舱记录'
      "
      :visible.sync="exportPackingOrderOptions.visible"
      :shipmentCode="exportPackingOrderOptions.shipmentCode"
      @confirm="confirm"
    />
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @confirmClose="confirmClose"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import exportTasks from './export-tasks'
import ExportPackingOrder from '../export-packing-order'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { ExportPackingOrder, ChooseTemplate },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      exportTasks: exportTasks(this),
      exportPackingOrderOptions: {
        visible: false,
        shipmentCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
        exportParams: {
          shipmentCode: '',
        },
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-wait-settlement-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback(row) {
      this.$confirm(
        '确认要回退发运单【' + row.shipmentNo + '】吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.rollbackSubmit(row.shipmentCode, row.shipmentStatus)
      })
    },
    rollbackSubmit(shipmentCode, shipmentStatus) {
      this.loadingOpen()
      this.$api
        .shipmentInfoBackApi({
          shipmentCode: shipmentCode,
          shipmentStatus: shipmentStatus,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    settlementCompleted(shipmentCode) {
      this.$confirm(
        this.$l('tips_settlementCompleted') || '是否要进行发运完成操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .shipmentInfoSettlementCompletedApi({
              shipmentCode: shipmentCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
                type: 'success',
              })
              this.$emit('reload')
            })
        })
        .catch(() => {})
    },

    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      if (templateGroup === 'shipment-shippingadvice') {
        this.exportPackingOrderOptions = {
          visible: true,
          shipmentCode: shipmentCode,
        }
        this.chooseTemplateOptions = {
          visible: false,
          custCode,
          endCustCode,
          templateGroup,
          exportCheckUrl,
        }
        return
      }
    },
    exportCheckData({ task, shipmentCode }) {
      if ('shipping-notice' === task) {
        return this.$api.shipmentInfoShipmentCheckDataApi({ shipmentCode })
      }
    },
    confirm(data) {
      this.chooseTemplateOptions = {
        ...this.chooseTemplateOptions,
        visible: true,
        exportParams: { ...data },
      }
    },
    confirmClose() {
      this.exportPackingOrderOptions.visible = false
      this.$refs.packingOrder.clearCheck()
    },
  },
}
</script>
